import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { type SbRespRefineMenuFilterArtSize_itemSearch$key } from './__generated__/SbRespRefineMenuFilterArtSize_itemSearch.graphql.ts';
import { type SbRespRefineMenuFilterArtSize_user$key } from './__generated__/SbRespRefineMenuFilterArtSize_user.graphql.ts';
import { type SbRespRefineMenuFilterArtSize_filters$key } from './__generated__/SbRespRefineMenuFilterArtSize_filters.graphql.ts';
import { type SbSharedRefineMenuFilters_filters$data } from './../../SbSharedRefineMenu/SbSharedRefineMenuFilters/__generated__/SbSharedRefineMenuFilters_filters.graphql.ts';
import { type ArrayElement } from 'dibs-ts-utils/exports/ArrayElement.ts';

// components
import { SbSharedRefineMenuFilterArtSize } from './../../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilterArtSize.tsx';

type Props = {
    itemSearch: SbRespRefineMenuFilterArtSize_itemSearch$key;
    filters: SbRespRefineMenuFilterArtSize_filters$key;
    user: SbRespRefineMenuFilterArtSize_user$key;
    filterName: string;
    shouldUseExpandableList: boolean;
    values: ArrayElement<SbSharedRefineMenuFilters_filters$data>['values'];
    trackingOptions?: Record<string, unknown>;
};

export const SbRespRefineMenuFilterArtSize: FC<Props> = ({
    user: userRef,
    itemSearch: itemSearchRef,
    filters: filtersRef,
    filterName,
    values,
    shouldUseExpandableList,
    trackingOptions,
}) => {
    const itemSearch = useFragment(
        graphql`
            fragment SbRespRefineMenuFilterArtSize_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuFilterArtSize_itemSearch
            }
        `,
        itemSearchRef
    );

    const user = useFragment(
        graphql`
            fragment SbRespRefineMenuFilterArtSize_user on User {
                ...SbSharedRefineMenuFilterArtSize_user
            }
        `,
        userRef
    );

    const filters = useFragment(
        graphql`
            fragment SbRespRefineMenuFilterArtSize_filters on SearchBrowseFilter
            @relay(plural: true) {
                ...SbSharedRefineMenuFilterArtSize_filters
            }
        `,
        filtersRef
    );

    return (
        <SbSharedRefineMenuFilterArtSize
            itemSearch={itemSearch}
            user={user}
            filters={filters}
            filterName={filterName}
            values={values}
            shouldUseExpandableList={shouldUseExpandableList}
            size="medium"
            showInvalidRangeErrorMessage={false}
            trackingOptions={trackingOptions}
        />
    );
};
